var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "custom-box",
    {
      staticStyle: { "pointer-events": "auto" },
      attrs: {
        title: _vm.formData.id ? "修改" : "新增",
        visible: _vm.dialogFormVisible,
        "close-on-click-modal": false,
        "modal-append-to-body": true,
        modal: false
      },
      on: {
        "update:visible": function($event) {
          _vm.dialogFormVisible = $event
        },
        close: function($event) {
          return _vm.clearData()
        }
      }
    },
    [
      _c(
        "el-form",
        {
          ref: "ruleForm",
          staticClass: "popover",
          attrs: {
            model: _vm.formData,
            rules: _vm.rules,
            "label-width": "110px",
            "label-position": "left"
          }
        },
        [
          _c(
            "el-form-item",
            {
              staticClass: "lodingItem",
              attrs: { label: "母包类型名称", prop: "type_name" }
            },
            [
              _c("el-input", {
                attrs: { clearable: "", placeholder: "母包类型名称" },
                model: {
                  value: _vm.formData.type_name,
                  callback: function($$v) {
                    _vm.$set(_vm.formData, "type_name", $$v)
                  },
                  expression: "formData.type_name"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              staticClass: "lodingItem",
              attrs: { label: "母包类型描述", prop: "type_desc" }
            },
            [
              _c("el-input", {
                attrs: { clearable: "", placeholder: "母包类型描述" },
                model: {
                  value: _vm.formData.type_desc,
                  callback: function($$v) {
                    _vm.$set(_vm.formData, "type_desc", $$v)
                  },
                  expression: "formData.type_desc"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              staticClass: "lodingItem",
              attrs: { prop: "status", label: "游戏组状态" }
            },
            [
              _c(
                "el-radio-group",
                {
                  staticClass: "flex-1",
                  model: {
                    value: _vm.formData.status,
                    callback: function($$v) {
                      _vm.$set(_vm.formData, "status", $$v)
                    },
                    expression: "formData.status"
                  }
                },
                [
                  _c("el-radio", { attrs: { label: 1, border: "" } }, [
                    _vm._v("启用")
                  ]),
                  _c("el-radio", { attrs: { label: 2, border: "" } }, [
                    _vm._v("禁用")
                  ])
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            { staticStyle: { width: "100%" } },
            [
              _c(
                "el-form-item",
                { staticClass: "lodingItem", attrs: { prop: "" } },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.addContent }
                    },
                    [_vm._v("添加参数")]
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._l(_vm.formData.param_keys, function(domain, index) {
            return _c(
              "div",
              { key: index + "k", staticClass: "param_keysClass" },
              [
                _c(
                  "div",
                  {
                    staticClass: "lodingItem-operationFrame flex",
                    staticStyle: { "flex-wrap": "wrap" }
                  },
                  [
                    _c(
                      "el-select",
                      {
                        staticClass: "select-type",
                        attrs: {
                          clearable: "",
                          filterable: "",
                          placeholder: "类型"
                        },
                        model: {
                          value: domain.typeValue,
                          callback: function($$v) {
                            _vm.$set(domain, "typeValue", $$v)
                          },
                          expression: "domain.typeValue"
                        }
                      },
                      _vm._l(_vm.typeList, function(item) {
                        return _c("el-option", {
                          key: item.value,
                          attrs: { label: item.label, value: item.value }
                        })
                      }),
                      1
                    ),
                    domain.typeValue == "number"
                      ? [
                          _c(
                            "el-form-item",
                            {
                              staticClass: "btn-type",
                              attrs: {
                                prop: "param_keys." + index + ".numberKey",
                                "label-width": "60px",
                                rules: _vm.rules.value
                              }
                            },
                            [
                              _c("el-input", {
                                staticClass: "operationFrame-entity",
                                attrs: { clearable: "", placeholder: "请输入" },
                                model: {
                                  value: domain.numberKey,
                                  callback: function($$v) {
                                    _vm.$set(domain, "numberKey", $$v)
                                  },
                                  expression: "domain.numberKey"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              staticStyle: { width: "250px" },
                              attrs: {
                                prop: "param_keys." + index + ".numberVal",
                                "label-width": "60px"
                              }
                            },
                            [
                              _c("el-input", {
                                staticClass: "operationFrame-entity",
                                attrs: { placeholder: "此处可填默认值" },
                                model: {
                                  value: domain.numberVal,
                                  callback: function($$v) {
                                    _vm.$set(domain, "numberVal", $$v)
                                  },
                                  expression: "domain.numberVal"
                                }
                              })
                            ],
                            1
                          ),
                          _c("el-button", {
                            staticClass: "delete-btn",
                            attrs: {
                              size: "mini",
                              type: "danger",
                              circle: "",
                              icon: "el-icon-delete"
                            },
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                return _vm.removeContent(index)
                              }
                            }
                          })
                        ]
                      : _vm._e(),
                    domain.typeValue == "boolean"
                      ? [
                          _c(
                            "el-form-item",
                            {
                              staticClass: "btn-type",
                              attrs: {
                                prop: "param_keys." + index + ".booleanKey",
                                "label-width": "60px",
                                rules: _vm.rules.value
                              }
                            },
                            [
                              _c("el-input", {
                                staticClass: "operationFrame-entity",
                                attrs: { clearable: "", placeholder: "请输入" },
                                model: {
                                  value: domain.booleanKey,
                                  callback: function($$v) {
                                    _vm.$set(domain, "booleanKey", $$v)
                                  },
                                  expression: "domain.booleanKey"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              staticStyle: { width: "250px" },
                              attrs: {
                                prop: "param_keys." + index + ".booleanVal",
                                "label-width": "60px"
                              }
                            },
                            [
                              _c("el-input", {
                                staticClass: "operationFrame-entity",
                                attrs: { placeholder: "此处可填默认值" },
                                model: {
                                  value: domain.booleanVal,
                                  callback: function($$v) {
                                    _vm.$set(domain, "booleanVal", $$v)
                                  },
                                  expression: "domain.booleanVal"
                                }
                              })
                            ],
                            1
                          ),
                          _c("el-button", {
                            staticClass: "delete-btn",
                            attrs: {
                              size: "mini",
                              type: "danger",
                              circle: "",
                              icon: "el-icon-delete"
                            },
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                return _vm.removeContent(index)
                              }
                            }
                          })
                        ]
                      : _vm._e(),
                    domain.typeValue == "string"
                      ? [
                          _c(
                            "el-form-item",
                            {
                              staticClass: "btn-type",
                              attrs: {
                                prop: "param_keys." + index + ".stringKey",
                                "label-width": "60px",
                                rules: _vm.rules.value
                              }
                            },
                            [
                              _c("el-input", {
                                staticClass: "operationFrame-entity",
                                attrs: { clearable: "", placeholder: "请输入" },
                                model: {
                                  value: domain.stringKey,
                                  callback: function($$v) {
                                    _vm.$set(domain, "stringKey", $$v)
                                  },
                                  expression: "domain.stringKey"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              staticStyle: { width: "250px" },
                              attrs: {
                                prop: "param_keys." + index + ".stringVal",
                                "label-width": "60px"
                              }
                            },
                            [
                              _c("el-input", {
                                staticClass: "operationFrame-entity",
                                attrs: { placeholder: "此处可填默认值" },
                                model: {
                                  value: domain.stringVal,
                                  callback: function($$v) {
                                    _vm.$set(domain, "stringVal", $$v)
                                  },
                                  expression: "domain.stringVal"
                                }
                              })
                            ],
                            1
                          ),
                          _c("el-button", {
                            staticClass: "delete-btn",
                            attrs: {
                              size: "mini",
                              type: "danger",
                              circle: "",
                              icon: "el-icon-delete"
                            },
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                return _vm.removeContent(index)
                              }
                            }
                          })
                        ]
                      : _vm._e(),
                    domain.typeValue == "map"
                      ? [
                          _c(
                            "el-form-item",
                            {
                              staticClass: "btn-type",
                              attrs: {
                                prop: "param_keys." + index + ".mapParams",
                                "label-width": "60px",
                                rules: _vm.rules.value
                              }
                            },
                            [
                              _c("el-input", {
                                staticClass: "operationFrame-entity",
                                attrs: {
                                  clearable: "",
                                  placeholder: "请输入对象名称"
                                },
                                model: {
                                  value: domain.mapParams,
                                  callback: function($$v) {
                                    _vm.$set(domain, "mapParams", $$v)
                                  },
                                  expression: "domain.mapParams"
                                }
                              })
                            ],
                            1
                          ),
                          _c("el-button", {
                            staticClass: "delete-btn",
                            attrs: {
                              size: "mini",
                              type: "primary",
                              circle: "",
                              icon: "el-icon-plus"
                            },
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                return _vm.addMapData(index)
                              }
                            }
                          }),
                          _c("el-button", {
                            staticClass: "delete-btn",
                            attrs: {
                              size: "mini",
                              type: "danger",
                              circle: "",
                              icon: "el-icon-delete"
                            },
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                return _vm.removeContent(index)
                              }
                            }
                          }),
                          _vm._l(domain.mapData, function(item, idx) {
                            return _c(
                              "div",
                              { key: idx + "kl", staticClass: "flex-item" },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    staticClass: "btn-type",
                                    attrs: {
                                      prop:
                                        "param_keys." +
                                        index +
                                        ".mapData." +
                                        idx +
                                        ".key",
                                      "label-width": "60px",
                                      rules: _vm.rules.value
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      staticClass: "operationFrame-entity",
                                      attrs: {
                                        clearable: "",
                                        placeholder: "请输入"
                                      },
                                      model: {
                                        value: item.key,
                                        callback: function($$v) {
                                          _vm.$set(item, "key", $$v)
                                        },
                                        expression: "item.key"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    staticClass: "btn-type",
                                    attrs: {
                                      prop:
                                        "param_keys." +
                                        index +
                                        ".mapData." +
                                        idx +
                                        ".value",
                                      "label-width": "60px"
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      staticClass: "operationFrame-entity",
                                      attrs: {
                                        clearable: "",
                                        placeholder: "此处可填默认值"
                                      },
                                      model: {
                                        value: item.value,
                                        callback: function($$v) {
                                          _vm.$set(item, "value", $$v)
                                        },
                                        expression: "item.value"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c("el-button", {
                                  staticClass: "delete-btn",
                                  attrs: {
                                    size: "mini",
                                    type: "danger",
                                    circle: "",
                                    icon: "el-icon-delete"
                                  },
                                  on: {
                                    click: function($event) {
                                      $event.preventDefault()
                                      return _vm.removeMapItem(index, idx)
                                    }
                                  }
                                })
                              ],
                              1
                            )
                          })
                        ]
                      : _vm._e(),
                    domain.typeValue == "array"
                      ? [
                          _c(
                            "el-form-item",
                            {
                              staticClass: "btn-type",
                              attrs: {
                                prop: "param_keys." + index + ".arrayParams",
                                "label-width": "60px",
                                rules: _vm.rules.value
                              }
                            },
                            [
                              _c("el-input", {
                                staticClass: "operationFrame-entity",
                                attrs: {
                                  clearable: "",
                                  placeholder: "请输入列表名称"
                                },
                                model: {
                                  value: domain.arrayParams,
                                  callback: function($$v) {
                                    _vm.$set(domain, "arrayParams", $$v)
                                  },
                                  expression: "domain.arrayParams"
                                }
                              })
                            ],
                            1
                          ),
                          _c("el-button", {
                            staticClass: "delete-btn",
                            attrs: {
                              size: "mini",
                              type: "primary",
                              circle: "",
                              icon: "el-icon-plus"
                            },
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                return _vm.addArrayData(index)
                              }
                            }
                          }),
                          _c("el-button", {
                            staticClass: "delete-btn",
                            attrs: {
                              size: "mini",
                              type: "danger",
                              circle: "",
                              icon: "el-icon-delete"
                            },
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                return _vm.removeContent(index)
                              }
                            }
                          }),
                          _vm._l(domain.arrayData, function(item, idx) {
                            return _c(
                              "div",
                              {
                                key: idx + "k2",
                                staticClass: "flex-array-item",
                                staticStyle: { "flex-direction": "column" }
                              },
                              [
                                _c(
                                  "div",
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        staticClass: "select-type",
                                        attrs: {
                                          clearable: "",
                                          filterable: "",
                                          placeholder: "类型"
                                        },
                                        model: {
                                          value: _vm.typeArrayValue,
                                          callback: function($$v) {
                                            _vm.typeArrayValue = $$v
                                          },
                                          expression: "typeArrayValue"
                                        }
                                      },
                                      _vm._l(_vm.typeArrayList, function(item) {
                                        return _c("el-option", {
                                          key: item.value,
                                          attrs: {
                                            label: item.label,
                                            value: item.value
                                          }
                                        })
                                      }),
                                      1
                                    ),
                                    _c("el-button", {
                                      staticClass: "delete-btn",
                                      attrs: {
                                        size: "mini",
                                        type: "primary",
                                        circle: "",
                                        icon: "el-icon-plus"
                                      },
                                      on: {
                                        click: function($event) {
                                          $event.preventDefault()
                                          return _vm.addArrayItemData(
                                            index,
                                            idx
                                          )
                                        }
                                      }
                                    }),
                                    _c("el-button", {
                                      staticClass: "delete-btn",
                                      attrs: {
                                        size: "mini",
                                        type: "danger",
                                        circle: "",
                                        icon: "el-icon-delete"
                                      },
                                      on: {
                                        click: function($event) {
                                          $event.preventDefault()
                                          return _vm.removeItemContent(
                                            index,
                                            idx
                                          )
                                        }
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._l(item.arrChildrenItem, function(m, k) {
                                  return _c(
                                    "div",
                                    {
                                      key: k + "k3",
                                      staticClass: "flex-array-item",
                                      staticStyle: { "align-items": "center" }
                                    },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          staticClass: "btn-type",
                                          attrs: {
                                            prop:
                                              "param_keys." +
                                              index +
                                              ".arrayData." +
                                              idx +
                                              ".arrChildrenItem." +
                                              k +
                                              ".key",
                                            "label-width": "60px",
                                            rules: _vm.rules.value
                                          }
                                        },
                                        [
                                          _c("el-input", {
                                            staticClass:
                                              "operationFrame-entity",
                                            attrs: {
                                              clearable: "",
                                              placeholder: "请输入"
                                            },
                                            model: {
                                              value: m.key,
                                              callback: function($$v) {
                                                _vm.$set(m, "key", $$v)
                                              },
                                              expression: "m.key"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-form-item",
                                        {
                                          staticClass: "btn-type",
                                          attrs: {
                                            prop:
                                              "param_keys." +
                                              index +
                                              ".arrayData." +
                                              idx +
                                              ".arrChildrenItem." +
                                              k +
                                              ".value",
                                            "label-width": "60px"
                                          }
                                        },
                                        [
                                          _c("el-input", {
                                            staticClass:
                                              "operationFrame-entity",
                                            attrs: {
                                              clearable: "",
                                              placeholder: "此处可填默认值"
                                            },
                                            model: {
                                              value: m.value,
                                              callback: function($$v) {
                                                _vm.$set(m, "value", $$v)
                                              },
                                              expression: "m.value"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c("el-button", {
                                        staticClass: "delete-btn",
                                        attrs: {
                                          size: "mini",
                                          type: "danger",
                                          circle: "",
                                          icon: "el-icon-delete"
                                        },
                                        on: {
                                          click: function($event) {
                                            $event.preventDefault()
                                            return _vm.removeArrayItem(
                                              index,
                                              idx,
                                              k
                                            )
                                          }
                                        }
                                      })
                                    ],
                                    1
                                  )
                                })
                              ],
                              2
                            )
                          })
                        ]
                      : _vm._e()
                  ],
                  2
                )
              ]
            )
          })
        ],
        2
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c(
            "el-button",
            {
              attrs: { round: "" },
              on: {
                click: function($event) {
                  _vm.dialogFormVisible = false
                }
              }
            },
            [_vm._v("取消")]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "warning", round: "" },
              on: {
                click: function($event) {
                  return _vm.clearData(false)
                }
              }
            },
            [_vm._v("重置")]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "primary", round: "", loading: _vm.reqLoading },
              on: {
                click: function($event) {
                  return _vm.dataFormSubmit("ruleForm")
                }
              }
            },
            [_vm._v("确定")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }